import { Band, Heading, Icon, SkeletonBar, TextPassage } from '@petsmart-ui/sparky';
import sanitizeHtml from 'sanitize-html';

import { decodeEntityString } from '@libs/algolia/utils';
import { Divider } from '@libs/common-next';

import { type Promotion } from '@/entities/product';
import { BaseDrawer } from '@/shared/ui';

import { usePromoDetailsQuery } from '../model';

type PromoDrawerProps = {
    selectedPromo: Nullable<Promotion>;
    onCloseAction: () => void;
};

export const PromoDrawer = ({ selectedPromo, onCloseAction }: PromoDrawerProps) => {
    const { data, isLoading } = usePromoDetailsQuery({ promoKey: selectedPromo?.key ?? '' });

    return (
        <BaseDrawer
            closeOnClickOutside
            title="Offer Details"
            className="promo-drawer"
            testId="promo-drawer-drawer"
            isOpen={Boolean(selectedPromo?.key)}
            onCloseAction={onCloseAction}
        >
            <div className="promo-drawer__wrapper">
                <Band className="promo-drawer__icon">
                    <Icon name="tag" size="lg" />
                </Band>

                {selectedPromo?.text && (
                    <Heading size="body-lg-bold" tagName="h3">
                        {decodeEntityString(sanitizeHtml(selectedPromo.text))}
                    </Heading>
                )}
            </div>
            <Divider />
            <TextPassage className="promo-drawer__text">
                <Heading size="body-lg-bold" tagName="h3">
                    Terms and Conditions
                </Heading>

                {isLoading && (
                    <div className="promo-drawer__skeleton">
                        <SkeletonBar size="sm" />
                        <SkeletonBar size="sm" />
                        <SkeletonBar size="sm" />
                    </div>
                )}

                {data?.termsAndConditions && decodeEntityString(sanitizeHtml(data.termsAndConditions))}
            </TextPassage>
        </BaseDrawer>
    );
};
